export { Storage } from './storage';
